import React, { Fragment } from "react";
import StatsUtils from "../../../utils/stats";

const KpiIndicator = props => {
  const kpi = props.kpi || {};
  const data = props.data || [];
  const kpiLabel = kpi.long_label || "";

  let sumOfValue = 0;
  let nbValues = 0;

  for (let i = 0; i < data.length; i++) {
    const dataObj = data[i] || {};
    const dataElt = dataObj.data || [];
    const lastElt = dataElt[dataElt.length - 1] || {};
    if (lastElt.hasOwnProperty("v")) {
      nbValues++;
      sumOfValue += lastElt.v;
    }
  }

  let value = nbValues === 0 ? null : sumOfValue;

  //override with indicator
  if (props.statsObj.hasOwnProperty("indicator")) {
    value = props.statsObj.indicator;
  }

  return (
    <Fragment>
      <span className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s">{kpiLabel}</span>
      <span className="p-stats-indicator-value">{StatsUtils.formatKpiValue(kpi, value)}</span>
    </Fragment>
  );
};

export default KpiIndicator;



// WEBPACK FOOTER //
// src/modules/stats/components/KpiIndicator.js